module.exports = __webpack_public_path__ + "static/media/18_img.27ffd31e.png";